import React from 'react';
import {t} from '@lingui/core/macro';

import FiltersModal from 'shared/ui/Modal/FiltersModal/FiltersModal';
import {FILTERS_KEPT_SEARCH} from 'shared/lib/filterHelper';
import {IPortMonitorListItem} from 'features/port/model/PortMonitor/IPortMonitor';

import PortIncidentsFiltersFormHandler from './PortIncidentsFiltersFormHandler';

interface IPortIncidentsFiltersModalProps {
    monitors: IPortMonitorListItem[],
    open: boolean,
    handleClose: () => void,
}

const PortIncidentsFiltersModal: React.FC<IPortIncidentsFiltersModalProps> = ({monitors, open, handleClose}) => (
    <FiltersModal header={t`Фильтры`} open={open} handleClose={handleClose} keepParams={FILTERS_KEPT_SEARCH}>
        <PortIncidentsFiltersFormHandler
            monitors={monitors}
            onSuccess={handleClose}
            handleClose={handleClose}
        />
    </FiltersModal>
);

export default PortIncidentsFiltersModal;
